import React from 'react';
import { useUpgradeMembershipContext } from '../../../../utils/ContextProviders/UpgradeContext';
import { HeadlineSection } from '../HeadlineSection';
import styles from './OneMillionContainer.module.scss';

const title = {
  firstSlot: 'See Why Over ',
  secondSlot: '1 Million Members',
  thirdSlot: 'Trust Us',
};

const OneMillionContainer = () => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { firstSlot, secondSlot, thirdSlot } = title;
  return (
    <section className={styles.wrapper}>
      <HeadlineSection
        firstSlot={firstSlot}
        secondSlot={secondSlot}
        thirdSlot={thirdSlot}
      />
    </section>
  );
};

export { OneMillionContainer };
